var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { useAppContext } from "../hooks";
import { Model } from "../model";
var isViewableRouting = function (router) {
    return (Object.hasOwnProperty.call(router, 'viewController') &&
        router.viewController &&
        typeof router.viewController.render === 'function');
};
export var useRib = function (configure) {
    var getErrorListener = useAppContext().getErrorListener;
    var _a = useState(false), loaded = _a[0], setLoaded = _a[1];
    var ribRef = useRef(configure().build());
    var unmountRef = useRef(false);
    useEffect(function () {
        var router = ribRef.current.router;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, router.load()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        getErrorListener().onCatchError(err_1);
                        return [3 /*break*/, 3];
                    case 3:
                        if (!unmountRef.current) {
                            setLoaded(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            unmountRef.current = true;
            try {
                router.unload();
            }
            catch (err) {
                getErrorListener().onCatchError(err);
            }
        };
    }, []);
    return {
        element: isViewableRouting(ribRef.current.router)
            ? ribRef.current.router.viewController.render()
            : null,
        actionable: ribRef.current.actionable,
        loaded: loaded
    };
};
export function useInteractor(builder, _a) {
    var _this = this;
    var _b = (_a === void 0 ? {} : _a).autoActivate, autoActivate = _b === void 0 ? true : _b;
    var metaModelRef = useRef(null);
    if (!metaModelRef.current) {
        metaModelRef.current = new Model({ activated: false });
    }
    var iRef = useRef(null);
    if (!iRef.current) {
        iRef.current = builder();
    }
    var activate = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ((_a = iRef.current) === null || _a === void 0 ? void 0 : _a.activate())];
                case 1:
                    _c.sent();
                    (_b = metaModelRef.current) === null || _b === void 0 ? void 0 : _b.update(function (value) {
                        value.activated = true;
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var deactivate = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ((_a = iRef.current) === null || _a === void 0 ? void 0 : _a.deactivate())];
                case 1:
                    _c.sent();
                    (_b = metaModelRef.current) === null || _b === void 0 ? void 0 : _b.update(function (value) {
                        value.activated = false;
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (autoActivate) {
            activate().catch(function (err) {
                console.error(err);
            });
        }
        return function () {
            deactivate()
                .then(function () {
                var _a;
                (_a = metaModelRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
            })
                .catch(function (err) {
                console.error(err);
            });
        };
    }, []);
    return {
        interactor: iRef.current,
        meta: metaModelRef.current,
        activate: activate,
        deactivate: deactivate
    };
}
//# sourceMappingURL=hooks.js.map